export default __webpack_public_path__ + "static/media/star.19478262.png";